<div class="alert {{ cssClass }} alert-dismissible fade show" *ngIf="alertMessage?.type">
    <h4 class="alert-heading">{{ alertMessage?.title }}</h4>
    <hr />
    <p class="mb-0">{{ alertMessage?.description }}</p>
</div>
